import { stationConfigurationsTypes } from "./types";

const {
    SET_STATION_CONFIGURATIONS_FILTERS,
    CLEAR_STATION_CONFIGURATIONS,
    SET_COMPANY_DATA,
    RESTORE_INITIAL,
} = stationConfigurationsTypes

const INITIAL_STATE = {
    company: null,
}

export const stationConfigurationsReducer = (state = INITIAL_STATE, { type, payload }) => {

    switch (type) {

        case SET_STATION_CONFIGURATIONS_FILTERS:
            return {
                ...state,
                [payload.key]: payload.data,
            };

        case SET_COMPANY_DATA:
            return {
                ...state,
                company: {
                    ...state.company,
                    stations: state.company.stations.map((station) =>
                        station.id === payload.id ? { ...station, ...payload } : station
                    )
                }
            }
        case CLEAR_STATION_CONFIGURATIONS:
            return {
                ...state,
                ...INITIAL_STATE,
            };
        case RESTORE_INITIAL:
            return INITIAL_STATE

        default:
            return state
    }
}